import { useLayoutEffect, useRef, useState, } from 'react';
export const useGetDropdownPosition = ({ isOpen, maxWidth = 0, resizeDeps = [], direction, }) => {
    const [dropdownStyles, setDropdownStyles] = useState(null);
    const [hasParent, setHasParent] = useState();
    const fieldRef = useRef(null);
    const dropdownRef = useRef(null);
    const initHeightRef = useRef(null);
    function handleSize() {
        const styles = setSize({
            isOpen,
            fieldRef,
            dropdownRef,
            initHeightRef,
            setHasParent,
            maxWidth,
            direction,
        });
        setDropdownStyles(styles);
    }
    useLayoutEffect(() => {
        if (hasParent && fieldRef.current) {
            hasParent.addEventListener('scroll', handleSize);
            window.addEventListener('scroll', handleSize);
        }
        return () => {
            if (hasParent && fieldRef.current) {
                hasParent.removeEventListener('scroll', handleSize);
                window.removeEventListener('scroll', handleSize);
            }
        };
    }, [hasParent]);
    useLayoutEffect(() => {
        setDropdownStyles((x) => {
            let width;
            if (fieldRef.current) {
                width = fieldRef.current.offsetWidth;
            }
            return Object.assign(Object.assign({}, x), { width });
        });
    }, []);
    useLayoutEffect(() => {
        handleSize();
        window.addEventListener('resize', handleSize);
        return () => window.removeEventListener('resize', handleSize);
    }, [isOpen, ...resizeDeps]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        fieldRef,
        dropdownRef,
        dropdownStyles,
    };
};
function setSize({ isOpen, fieldRef, dropdownRef, initHeightRef, setHasParent, maxWidth, direction = [], }) {
    function getScrollParent(node) {
        if (node == null) {
            return null;
        }
        if (node.scrollHeight > node.clientHeight) {
            return node;
        }
        else {
            return getScrollParent(node.parentNode);
        }
    }
    function getSpaceTop() {
        return fieldRef.current.getBoundingClientRect().top - parentModalSpace() - 10;
    }
    function parentModalSpace() {
        const parent = fieldRef.current.closest('.modal-dialog');
        let modalParentSpace;
        if (parent) {
            modalParentSpace = window.getComputedStyle(parent, null).getPropertyValue('margin-bottom');
        }
        return parseFloat(modalParentSpace) ? parseFloat(modalParentSpace) - 5 : 20;
    }
    function getSpaceBottom() {
        return (window.innerHeight - fieldRef.current.getBoundingClientRect().bottom - parentModalSpace() - 10);
    }
    function getSpaceLeft() {
        var _a;
        const parentLeft = ((_a = fieldRef.current.closest('.parent-for-dropdown')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0;
        return fieldRef.current.getBoundingClientRect().left - parentLeft - parentModalSpace() - 10;
    }
    function getSpaceRight() {
        return (window.innerWidth - fieldRef.current.getBoundingClientRect().right - parentModalSpace() - 10);
    }
    function getTop(dropdownHeight, onTop) {
        const spaceTop = fieldRef.current.getBoundingClientRect().top;
        const spaceBottom = fieldRef.current.getBoundingClientRect().bottom;
        if (onTop) {
            return spaceTop - dropdownHeight - 10;
        }
        else {
            return spaceBottom + 10;
        }
    }
    function getRight(dropdownWidth, toLeft) {
        const spaceRight = window.innerWidth - fieldRef.current.getBoundingClientRect().right;
        if (toLeft) {
            return spaceRight;
        }
        else {
            return spaceRight - (dropdownWidth - fieldRef.current.getBoundingClientRect().width);
        }
    }
    if (fieldRef.current && dropdownRef.current && isOpen) {
        const spaceTop = getSpaceTop();
        const spaceBottom = getSpaceBottom();
        const spaceLeft = getSpaceLeft();
        const spaceRight = getSpaceRight();
        let dropdownHeight = dropdownRef.current.clientHeight;
        let dropdownWidth = dropdownRef.current.clientWidth;
        let fieldWidth = fieldRef.current.clientWidth;
        if (initHeightRef.current === null) {
            initHeightRef.current = dropdownHeight;
        }
        const minHeight = 44;
        const parent = getScrollParent(fieldRef.current);
        if (parent) {
            setHasParent(parent);
        }
        else {
            setHasParent(null);
        }
        let height = dropdownHeight;
        let width = maxWidth ? Math.min(maxWidth, Math.max(dropdownWidth, fieldWidth)) : fieldWidth;
        let onTop = false;
        let toLeft = false;
        if (direction.includes('top') ||
            (spaceBottom < minHeight * 6 && spaceBottom < spaceTop && !direction.includes('bottom'))) {
            onTop = true;
        }
        if (direction.includes('left') || (!direction.includes('right') && width > spaceRight)) {
            toLeft = true;
        }
        if (height > spaceBottom && !onTop) {
            height = spaceBottom;
        }
        if (height < minHeight) {
            height = Math.min(initHeightRef.current, minHeight);
        }
        if (spaceBottom > height && !onTop) {
            if (initHeightRef.current !== null && spaceBottom >= initHeightRef.current) {
                height = null;
            }
            else {
                height = spaceBottom;
            }
        }
        return {
            maxWidth: maxWidth,
            minWidth: width,
            height: height && !onTop ? height : 'initial',
            top: getTop(height, onTop),
            right: getRight(width, toLeft),
        };
    }
}
